import { createSelector } from 'reselect';

import { RootState } from 'store/types';

export const specialtiesSelector = (state: RootState) => state.booking.specialties;

export const specialtiesFetchingSelector = createSelector(
  specialtiesSelector,
  specialties => specialties.isFetching
);

export const specialtiesErrorSelector = createSelector(
  specialtiesSelector,
  specialties => specialties.error
);

export const specialtiesDataSelector = createSelector(
  specialtiesSelector,
  specialties => specialties.data
);

export const getSpecialtiesSortedByName = createSelector(specialtiesSelector, specialties =>
  specialties.data.slice().sort((a, b) => (a.nameLong > b.nameLong ? 1 : -1))
);
